import { render, staticRenderFns } from "./SecurityDepositTable.vue?vue&type=template&id=1d47ba53&scoped=true&"
import script from "./SecurityDepositTable.vue?vue&type=script&lang=js&"
export * from "./SecurityDepositTable.vue?vue&type=script&lang=js&"
import style0 from "./SecurityDepositTable.vue?vue&type=style&index=0&id=1d47ba53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47ba53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDataTable,VSkeletonLoader,VSnackbar})
